import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import {
  ITEMAUTOTOPUPBILLING,
  ITEMTRANSACTIONAUTO,
  RESPONSEAUTOVALIDCUSTOMER,
  RESPONSEBASE,
  RESPONSECREATEAUTO,
} from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchAutoTopUpAuthService,
  fetchAutoTopUpCreateService,
  fetchAutoTopUpDeleteService,
  fetchAutoTopUpListProviderService,
  fetchAutoTopUpListService,
  fetchAutoTopUpTransactionService,
  fetchAutoTopUpValidPhoneService,
} from "../services/auto-top-up.service";
import {
  fetchAutoTopUpAuthorizationFailure,
  fetchAutoTopUpAuthorizationSuccess,
  fetchAutoTopUpCreateFailure,
  fetchAutoTopUpCreateSuccess,
  fetchAutoTopUpValidPhoneFailure,
  fetchAutoTopUpValidPhoneSuccess,
  fetchAutoTopUpListFailure,
  fetchAutoTopUpListSuccess,
  fetchAutoTopUpDeleteFailure,
  fetchAutoTopUpDeleteSuccess,
  fetchAutoTopUpListProviderSuccess,
  fetchAutoTopUpListProviderFailure,
  fetchAutoTopUpTransactionSuccess,
  fetchAutoTopUpTransactionFailure,
} from "./actions";
import {
  FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_REQUEST,
  FETCH_AUTO_TOP_UP_CREATE_REQUEST,
  FETCH_AUTO_TOP_UP_VALID_PHONE_REQUEST,
  FETCH_AUTO_TOP_UP_LIST_REQUEST,
  FETCH_AUTO_TOP_UP_DELETE_REQUEST,
  FETCH_AUTO_TOP_UP_LIST_PROVIDER_REQUEST,
  FETCH_AUTO_TOP_UP_TRANSACTION_REQUEST,
} from "./actions.type";
import {
  FetchAutoTopUpAuthorizationRequest,
  FetchAutoTopUpCreateRequest,
  FetchAutoTopUpDeleteRequest,
  FetchAutoTopUpTransactionRequest,
  FetchAutoTopUpValidPhoneRequest,
} from "./types";

function* fetchAutoTopUpListSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchAutoTopUpListService);
    console.log("fetchAutoTopUpList info response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      const data: ITEMAUTOTOPUPBILLING[] = response?.data?.data;
      yield put(fetchAutoTopUpListSuccess(data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoTopUpListFailure(msg));
  }
}

function* fetchAutoTopUpDeleteSaga(action: FetchAutoTopUpDeleteRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEAUTOVALIDCUSTOMER> = yield call(() => fetchAutoTopUpDeleteService(action));
    console.log("fetchAutoTopUpDelete info response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchAutoTopUpDeleteSuccess(response?.data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoTopUpDeleteFailure(msg));
  }
}

function* fetchAutoTopUpListProviderSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchAutoTopUpListProviderService);
    console.log("fetchAutoTopUpListProvider response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      const data: Array<string> = response?.data.data;
      yield put(fetchAutoTopUpListProviderSuccess(data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoTopUpListProviderFailure(msg));
  }
}

function* fetchAutoTopUpValidPhoneSaga(action: FetchAutoTopUpValidPhoneRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEAUTOVALIDCUSTOMER> = yield call(() => fetchAutoTopUpValidPhoneService(action));
    console.log("fetchAutoTopUpValidPhone response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchAutoTopUpValidPhoneSuccess(response?.data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoTopUpValidPhoneFailure(msg));
  }
}

function* fetchAutoTopUpCreateSaga(action: FetchAutoTopUpCreateRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSECREATEAUTO> = yield call(() => fetchAutoTopUpCreateService(action.payload));
    console.log("fetchAutoTopUpCreate response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchAutoTopUpCreateSuccess(response?.data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoTopUpCreateFailure(msg));
  }
}

function* fetchAutoTopUpAuthSaga(action: FetchAutoTopUpAuthorizationRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<any> = yield call(() => fetchAutoTopUpAuthService(action));
    console.log("fetchAutoTopUpAuth response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchAutoTopUpAuthorizationSuccess());
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoTopUpAuthorizationFailure(getErrorEndOTP(e), msg));
  }
}

function* fetchAutoTopUpTransactionSaga(action: FetchAutoTopUpTransactionRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<ITEMTRANSACTIONAUTO[]> = yield call(() => fetchAutoTopUpTransactionService(action));
    console.log("fetchAutoTopUpCreate response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchAutoTopUpTransactionSuccess(response?.data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoTopUpTransactionFailure(msg));
  }
}

function* autoTopUpSaga() {
  yield all([
    takeLatest(FETCH_AUTO_TOP_UP_LIST_REQUEST, fetchAutoTopUpListSaga),
    takeLatest(FETCH_AUTO_TOP_UP_DELETE_REQUEST, fetchAutoTopUpDeleteSaga),
    takeLatest(FETCH_AUTO_TOP_UP_LIST_PROVIDER_REQUEST, fetchAutoTopUpListProviderSaga),
    takeLatest(FETCH_AUTO_TOP_UP_VALID_PHONE_REQUEST, fetchAutoTopUpValidPhoneSaga),
    takeLatest(FETCH_AUTO_TOP_UP_CREATE_REQUEST, fetchAutoTopUpCreateSaga),
    takeLatest(FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_REQUEST, fetchAutoTopUpAuthSaga),
    takeLatest(FETCH_AUTO_TOP_UP_TRANSACTION_REQUEST, fetchAutoTopUpTransactionSaga),
  ]);
}

export default autoTopUpSaga;
